module.exports = __webpack_public_path__ + "media/images/logos/Canterbury-University-f7280048047a6a6601cc72579b2181fb.svg";